<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading"/>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card style="border-radius: 10px;">
        <div slot="header">
          <h3 class="card-title mb-0">Datos básicos</h3>
        </div>
        <div class="columns">
          <div class="column is-3">
            <CompanySelector v-model="companyId"/>
          </div>
          <div class="column is-3">
            <b-field label="Métodos de pago *">
              <treeselect
                  :options="payMethods"
                  v-model="method"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  name="payMethods"
                  v-validate="'required'"
                  placeholder="Seleccione método de pago"
                  @select="select"
              />
            </b-field>
          </div>
          <div class="col-3">
            <b-button @click="addMethod" type="is-info"
                      style="margin-top: 44px;">
              Adicionar método
            </b-button>
          </div>
        </div>
        <div class="columns">

        </div>
      </vs-card>

      <vs-card v-if="payMethodsList && payMethodsList.length > 0">
        <div :key="forceRender">
          <vs-tabs>
            <vs-tab
                :label="payMethod.method.title"
                v-for="(payMethod,index) in payMethodsList"
                :key="index">
              <MethodDetail
                  :company-id="parseInt(companyId)"
                  :payMethod="payMethod"
                  @save="save"
                  @deleteMethod="deleteMethod"
              />
            </vs-tab>
          </vs-tabs>
        </div>

      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import globalEndpoint from "@/endpoints/core/GlobalEndpoint";
import kind from "@/global/lasting/EKind";
import toast from "@/global/ToastConfig";
import {get as getProp} from "object-path";
import deviceEndpoint from "@/endpoints/core/DeviceEndpoint";
import TreeSelect from "@riophae/vue-treeselect";
import MethodDetail from "@/views/pay/methods/payMethodDetail/MethodDetail.vue";
import methodSettingEndpoint from "@/endpoints/core/MethodSettingEndpoint";


export default {
  name: "paymentMethod",
  components: {
    MethodDetail,
    TreeSelect,
    CompanySelector
  },
  data() {
    return {
      isLoading: false,
      companyId: null,
      method: null,
      selectedMethod: null,
      payMethods: [],
      payMethodsList: [],
      devicesList: [],
      device: null,
      selectedDevice: null,
      selectedDeviceList: [],
      methodSettingDetailList: [],
      forceRender: 0
    };
  },
  mounted() {
    globalEndpoint.getUnityListByKinds(kind.WAY_PAY, "método de pago")
        .then((info) => this.payMethods = info);
    deviceEndpoint.getListDeviceByCompany(this.companyId)
  },
  watch: {
    companyId() {
      this.payMethodsList = [];
      this.getListMethodsSetting();
    }
  },
  methods: {
    async getListMethodsSetting() {
      this.isLoading = true;
      const listMethods = await methodSettingEndpoint.getlistMethodSettingByCompany();
      this.payMethodsList = listMethods.map(
          (method, index) => {
            method.position = index;
            return method;
          });
      this.isLoading = false;
    },
    validateMethodPay() {
      let exists = false;
      if (this.payMethodsList) {
        exists = this.payMethodsList.some((method) => {
          return method.method.code === this.selectedMethod.code
        });
      }
      return exists;
    },
    addMethod() {
      try {
        if (this.validateMethodPay()) {
          toast.error("El método de pago " + this.selectedMethod.title + " ya fue seleccionado");
          return;
        }
        this.validateAddMethod();
        const paymentMethod = {
          code: null,
          company: {code: this.companyId},
          method: {
            code: this.selectedMethod.code,
            initials: this.selectedMethod.initials,
            title: this.selectedMethod.title,
          },
          position: this.payMethodsList.length,
          methodSettingDetailList: [],
        };
        this.payMethodsList.push(paymentMethod);
        console.log("Adicionando ...", this.payMethodsList);
        this.method = null;
      } catch (ex) {
        toast.error(ex.message);
      }
    },
    validateAddMethod() {
      if (!this.companyId) {
        throw new Error("Debe seleccionar una empresa");
      }
      if (!this.method) {
        throw  new Error("Debe seleccionar un método de pago");
      }
    },
    deleteMethod(method) {
      this.payMethodsList.splice(method.position, 1);
      this.payMethodsList.forEach((item, index) => item.position = index);
      this.forceRender++;
    },
    select(payMethod) {
      const payMethodId = getProp(payMethod, "code");
      this.selectedMethod = this.payMethods.find(value => value.code === payMethodId);
    },

    save() {
      try {
        this.validateSave();
        this.isLoading = true;
        methodSettingEndpoint.save(this.payMethodsList)
            .then(result => {
              if (result > 0) {
                toast.ok("Se guardó la configuración correctamente");
                this.payMethodsList = [];
                this.getListMethodsSetting();
              }
              this.isLoading = false;
            });
      } catch (ex) {
        toast.error(ex.message);
      }
    },

    validateSave() {
      this.payMethodsList.forEach(method => {
        const title = method.method.title;
        if (method.methodSettingDetailList && method.methodSettingDetailList.length === 0) {
          throw new Error("Por favor adicionar un dispositivo al medio de pago " + title);
        }
      });
    }

  }
}
</script>


<style>
.con-vs-tabs, .con-vs-tabs .con-slot-tabs {
  overflow: unset !important;
}

</style>
